<template>
  <div class="comp-list">
    <InteractionBar
      v-if="filters.length > 0"
      :actions="filters"
      @interaction="$emit('interaction', $event)"
    />
    <table>
      <ListHeader :structure="structure" :sort.sync="sort" :no-interaction-bar="filters.length === 0"/>
      <tbody>
        <tr v-if="!data" class="loader">
          <td :colspan="colspan">
            <Loader colspan="str"/>
          </td>
        </tr>
        <tr v-if="data && data.length === 0" class="empty">
          <td :colspan="colspan">
            <span>Keine Ergebnisse</span>
          </td>
        </tr>
        <ListItem
          v-for="(row, idx) in computedData"
          :structure="structure"
          :data="row"
          :key="`list-item-${idx}`"
          @select="$emit('select', row)"
          @reload="$emit('reload')"
          @context="$emit('context', { currentTarget: $event.currentTarget, row })"
          />
      </tbody>
    </table>
    <Paginator
      v-if="total > 0"
      :offset.sync="offset"
      :limit="limit"
      :total="total"
    />
  </div>
</template>

<script>
  import InteractionBar from '@/components/ui/inputs/InteractionBar';
  import ListHeader from '@/components/ui/list/ListHeader';
  import Paginator from '@/components/ui/list/Paginator';
  import ListItem from '@/components/ui/list/ListItem';
  import Sort from '@/utils/Sort';
  import Loader from '@/components/ui/Loader';

  export default {
    name: 'List',
    components: {
      Paginator,
      Loader,
      ListItem,
      ListHeader,
      InteractionBar,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      filters: {
        type: Array,
        default: () => [],
      },
      actions: {
        type: Array,
        default: () => [],
      },
      structure: {
        type: Object,
        default: () => {},
      },
      sort: {
        type: Object,
        default: () => ({
          column: null,
          ascending: false,
        }),
      },
      data: {
        type: Array,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        offset: 1,
        limit: 50,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedData() {
        const out = (this.data || []).slice();
        const { property, ascending } = this.sort;
        const struct = this.structure[property];

        let sortFn;
        if (struct?.sort) {
          sortFn = struct.sort;
        } else {
          sortFn = Sort.list.default;
        }
        sortFn = sortFn({ property, ascending });
        out.sort(sortFn);
        if (!ascending) {
          out.reverse();
        }

        const offset = this.offset;
        const limit = this.limit;
        const start = (offset * limit) - limit;
        const end = start + limit;
        return out.slice(start, end);
      },
      total() {
        const out = (this.data || []).slice();
        return out.length;
      },
      colspan() {
        const keys = Object.keys(this.structure || {});
        return keys.length + 2;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      offset() {
        const scrollTop = document.documentElement.scrollTop;
        const rect = document.querySelector('.comp-list').getBoundingClientRect();
        window.scrollTo({
          top: scrollTop + rect.y,
          left: 0,
          behavior: 'auto',
        });
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-list {
  position: relative;
  background-color: $color-white-solid-10;
  box-shadow: $box-shadow-2;
  min-height: 48px;
  border-radius: $default-border-radius;

  & > .comp-interactionbar {
    width: 100%;
    background-color: $color-white-solid-10;
    position: sticky;
    top: 0;
    z-index: 3;
  }

  & > table {
    position: relative;
    width: 100%;
    border-spacing: 0;
    border-color: transparent;
    table-layout: fixed;

    tr.loader td {
      height: 80px;
    }

    tr.empty td {
      height: 80px;
      text-align: center;
      @include font-body-medium;
    }
  }
}
</style>
